import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-interaction-dialog',
  templateUrl: './user-interaction-dialog.component.html',
  styleUrls: ['./user-interaction-dialog.component.scss']
})
export class UserInteractionDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
